class BaseWindow {
    constructor(options) {
        this.wrapper = document.querySelector(options.wrapper);
        this.buttonTrigger = options.buttonTrigger;
    }

    openWindow() {
        document.querySelectorAll(`[${this.buttonTrigger}]`).forEach((openBtn) => {
            openBtn.addEventListener('click', () => {
                this.wrapper.classList.remove('hidden');
                if ( this.wrapper.querySelector('[data-textarea]') && this.wrapper.querySelector('[data-textarea]').contentEditable === 'true') {
                    this.wrapper.querySelector('[data-textarea]').focus();
                }
            });
        });
    }

    closeWindow() {
        document.querySelectorAll('[data-close-pay-window]').forEach((closeBtn) => {
            closeBtn.addEventListener('click', (event) => {
                const payWindow = event.target.closest('.pay-window');
                const isCloseButton = event.target.closest('button') && event.target.closest('button').classList.contains('pay-window-close-mobile');
                if (payWindow && !isCloseButton) {
                    return;
                }
                    this.wrapper.classList.add('hidden');
            });
        });
    }

    selectSocialMethod() {
        const container = this.wrapper.querySelector('[data-social-method-container]');
        if (container) {
            const socials = container.querySelectorAll('[data-soc]');
            const socialValueInput = container.querySelector('.social-value');
            const socialTypeInput = container.querySelector('.social-type');
            container.addEventListener('click', (e) => {
                const socialBtn = e.target.closest('[data-soc]');
                if (socialBtn) {
                    socials.forEach(soc => soc.classList.remove('_active'));
                    socialValueInput.value = '';
                    socialTypeInput.value = '';
                    socialValueInput.disabled = false;

                    socialBtn.classList.add('_active');
                    socialTypeInput.value = socialBtn.dataset.soc;

                    if (socialBtn.dataset.value || socialBtn.dataset.soc === 'email') {
                        socialValueInput.value = socialBtn.dataset.value;
                        if (socialBtn.dataset.soc === 'email') {
                            socialValueInput.disabled = true;
                        }
                    }
                    if (socialBtn.classList.contains('_primary')) {
                        container.querySelector('[data-primary-true]').classList.remove('d-none');
                        container.querySelector('[data-primary-true]').classList.add('d-flex');
                        container.querySelector('[data-primary-method]').classList.remove('d-flex');
                        container.querySelector('[data-primary-method]').classList.add('d-none');
                    } else {
                        container.querySelector('[data-primary-method]').classList.remove('d-none');
                        container.querySelector('[data-primary-method]').classList.add('d-flex');
                        container.querySelector('[data-primary-true]').classList.remove('d-flex');
                        container.querySelector('[data-primary-true]').classList.add('d-none');
                    }
                }
            });
        }
    }
}

class ModalWindow extends BaseWindow {
    constructor(options) {
        super(options);
        this.textarea = this.wrapper.querySelector('[data-textarea]');
        this.modalSendBtn = this.wrapper.querySelector('[data-modal-send-btn]');
    }

    init() {
        super.openWindow();
        super.closeWindow();
        super.selectSocialMethod();
        this.validateTextarea();
        //this.sendMessage();
    }

    
    validateTextarea() {
        this.textarea.addEventListener('input', () => {
            if (this.textarea.textContent.length) {
                this.modalSendBtn.removeAttribute('disabled');
            } else {
                this.modalSendBtn.setAttribute('disabled', true);
            }
        });
    }
    sendMessage() {
        this.modalSendBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            console.log('click');
            console.log(this.textarea.innerText);
            console.log(this.wrapper.querySelector('.pay-window-social-method._active'))
        })
    }
}

class PayWindow extends BaseWindow {
    constructor(options) {
        super(options);
        this.step = 1;
        this.typeOfLession = null;
        this.payMethodIsSelected = false;
        this.validation = {
            firstStep: false,
            secondStep: true,
            thirdStep: false,
            fourthStep: false,
        };
        this.formData = {
            traningFormat: 'Individual',
            typeOfTraning: null,
            dayAndTime: null,
            paymentMethod: null,
        };
        this.stepCircles = document.querySelectorAll('[data-step-circle]');
    }

    init() {
        super.openWindow();
        super.closeWindow();
        this.stepForward();
        this.stepBack();
        this.chooseLession();
        this.selectLession();
        this.changePriceColor();
        this.selectPaymentMethod();
        super.selectSocialMethod();
        this.copyBill();
        this.appearanceDescription();
        this.removeDisabledBtnNext();
        this.billCopy();
    }
    stepForward() {
        if (this.wrapper.querySelector('[data-pay-window-btn-next]')) {
            this.wrapper.querySelector('[data-pay-window-btn-next]').addEventListener('click', () => {
                if (this.step !== 4) {
                    if (this.step === 1 && this.validation.firstStep) {
                        this.step++;
                    } else if (this.step === 2 && this.validation.firstStep && this.validation.secondStep) {
                        this.step++;
                    } else if (this.step === 3 && this.validation.firstStep && this.validation.secondStep && this.validation.thirdStep) {
                        this.wrapper.querySelector('[data-close-pay-window]').click();
                    }

                    if (this.step === 2) {
                        this.openSecondStepContent();
                    }
                    if (this.step === 3) {
                        this.openThirdStepContent();
                    }
                }
            });
        }
    }

    stepBack() {
        this.wrapper.querySelectorAll('[data-pay-window-btn-prev]').forEach(closeBtn => {
            closeBtn.addEventListener('click', () => {
                if (this.step !== 1) {
                    this.step--;

                    if (this.step === 1) {
                        this.openFirstStepContent();
                    }
                    if (this.step === 2) {
                        this.openSecondStepContent();
                    }
                }
            });
        });
    }

    openFirstStepContent() {
        this.stepCircleChange();
        this.wrapper.querySelector('[data-step-first]').classList.remove('hidden');
        this.wrapper.querySelector('[data-step-second]').classList.add('hidden');
        this.wrapper.querySelector('[data-step-third]').classList.add('hidden');
        this.wrapper.querySelectorAll('[data-pay-window-btn-prev]').forEach(btnPrev => {
            btnPrev.classList.add('hidden');
        });
    }

    openSecondStepContent() {
        this.stepCircleChange();
        this.wrapper.querySelector('[data-step-first]').classList.add('hidden');
        this.wrapper.querySelector('[data-step-second]').classList.remove('hidden');
        this.wrapper.querySelector('[data-step-third]').classList.add('hidden');
        this.wrapper.querySelectorAll('[data-pay-window-btn-prev]').forEach(btnPrev => {
            btnPrev.classList.remove('hidden');
        });
        this.wrapper.querySelector('[data-pay-window-btn-next]').innerText = 'Next →';
        this.wrapper.querySelector('[data-pay-window-btn-next]').classList.remove('paid');
        this.wrapper.querySelector('[data-description][data-description-first]').classList.add('hidden');
        this.wrapper.querySelector('[data-description][data-description-second]').classList.add('hidden');
    }

    openThirdStepContent() {
        this.stepCircleChange();
        this.wrapper.querySelector('[data-step-first]').classList.add('hidden');
        this.wrapper.querySelector('[data-step-second]').classList.add('hidden');
        this.wrapper.querySelector('[data-step-third]').classList.remove('hidden');
        this.wrapper.querySelector('[data-pay-window-btn-next]').innerText = 'I paid';
        this.wrapper.querySelector('[data-pay-window-btn-next]').classList.add('paid');
        if (this.payMethodIsSelected) {
            this.wrapper.querySelector('[data-description][data-description-first]').classList.remove('hidden');
            this.wrapper.querySelector('[data-description][data-description-second]').classList.remove('hidden');
        }
        if (this.wrapper.querySelector('[data-description][data-description-first]').classList.contains('hidden')) {
            this.wrapper.querySelector('[data-pay-window-btn-next]').classList.add('disabled');
        }
    }

    stepCircleChange() {
        this.stepCircles.forEach(circle => {
            circle.classList.remove('active');
        });
        this.stepCircles[this.step - 1].classList.add('active');
    }

    chooseLession() {
        this.wrapper.querySelectorAll('[data-type-item]').forEach(lession => {
            lession.addEventListener('click', () => {
                !this.validation.firstStep ? this.validation.firstStep = true : '';
                lession.querySelector('[data-type-item-input]').addEventListener('click', (e) => { e.stopPropagation(); });
                lession.querySelector('[data-type-item-input]').click();

                this.typeOfLession = lession.outerHTML;
                const selectLession = document.createElement('div');
                selectLession.innerHTML = this.typeOfLession;
                selectLession.querySelector('.pay-window-checkbox-circle').remove();
                this.wrapper.querySelectorAll('[data-insert-lession]').forEach(container => {
                    container.innerHTML = selectLession.outerHTML;
                });
            });
        });
    }

    selectLession() {
        const selectContainers = this.wrapper.querySelectorAll('[data-select-container]');
        if (selectContainers.length) {
            selectContainers.forEach(container => {
                const triggers = container.querySelectorAll('[data-select-trigger]');
                const content = container.querySelector('[data-select-content-pay-window]');
                const elements = content.querySelectorAll('[data-select-item]');

                if (triggers.length) {
                    triggers.forEach(trigger => {
                        trigger.addEventListener('click', (e) => {
                            e.stopPropagation();
                            if (container.querySelector('[data-select-content-pay-window]').classList.contains('mobile-hidden')) {
                                container.querySelector('[data-select-content-pay-window]').classList.remove('mobile-hidden');
                            } else {
                                container.querySelector('[data-select-content-pay-window]').classList.add('mobile-hidden');
                            }
                        });
                    });
                }

                if (elements.length) {
                    elements.forEach(element => {
                        element.addEventListener('click', (e) => {
                            const selectLession = element.cloneNode(true);

                            selectLession.querySelector('.pay-window-checkbox-circle').remove();
                            selectLession.querySelector('.pay-window-checkbox-input').remove();

                            selectLession.removeAttribute('data-type-item');
                            selectLession.removeAttribute('data-select-item');

                            container.querySelector('[data-select-trigger]').classList.add('padding-y-none');
                            container.querySelector('[data-select-inner]').innerHTML = '';
                            container.querySelector('[data-select-inner]').prepend(selectLession);
                            container.querySelector('[data-select-content-pay-window]').classList.add('mobile-hidden');
                        });
                    });
                }

                this.wrapper.querySelector('.pay-window').addEventListener('click', () => {
                    if (container.querySelector('[data-select-content-pay-window]').classList.contains('mobile-hidden')) {
                        container.querySelector('[data-select-content-pay-window]').classList.add('mobile-hidden');
                    } else {
                        container.querySelector('[data-select-content-pay-window]').classList.remove('mobile-hidden');
                    }
                });
            });
        }
    }

    selectPaymentMethod() {
        const container = this.wrapper.querySelector('[data-select-method-container]');
        if (container) {
            const trigger = container.querySelector('[data-select-method-trigger]');
            const content = container.querySelector('[data-select-method-content]');
            const methods = content.querySelectorAll('[data-select-method-item]');

            container.addEventListener('click', (e) => { e.stopPropagation(); });

            trigger.addEventListener('click', () => {
                if (content.classList.contains('hidden')) {
                    content.classList.remove('hidden');
                } else {
                    content.classList.add('hidden');
                }
            });

            methods.forEach(method => {
                method.addEventListener('click', () => {
                    this.validation.thirdStep = true;
                    this.payMethodIsSelected = true;
                    container.querySelector('[data-select-method-inner]').innerHTML = method.outerHTML;
                    this.wrapper.querySelector('[data-bill-insert]').innerText = method.dataset.bill;
                    content.classList.add('hidden');
                });
            });

            this.wrapper.querySelector('.pay-window').addEventListener('click', () => {
                if (!content.classList.contains('hidden')) {
                    content.classList.add('hidden');
                }
            });
        }
    }
    copyBill() {
        if (this.wrapper.querySelector('[data-bill-copy]')) {
            this.wrapper.querySelector('[data-bill-copy]').addEventListener('click', () => {
                navigator.clipboard.writeText(this.wrapper.querySelector('[data-bill-insert]').innerText);
            });
        }
    }

    changePriceColor() {
        const lessions = this.wrapper.querySelectorAll('[data-type-item]');
        if (lessions.length) {
            lessions.forEach(lession => {
                lession.addEventListener('click', () => {
                    let colorClass = lession.classList.contains('discount') ? 'c-tone-orange-2' : 'c-neutral-100';
                    let price = lession.querySelector('.pay-window-type-price').innerText;
                    this.wrapper.querySelector('[data-price-insert]').innerText = price;
                    this.wrapper.querySelector('[data-price-insert]').className = colorClass;
                });
            });
        }
    }

    appearanceDescription() {
        const methods = this.wrapper.querySelectorAll('[data-select-method-item]');
        if (methods.length) {
            methods.forEach(method => {
                const descriptions = this.wrapper.querySelectorAll('[data-description]');
                if (descriptions.length) {
                    method.addEventListener('click', () => {
                        descriptions.forEach(description => {
                            if (description.classList.contains('hidden')) {
                                description.classList.remove('hidden');
                            }
                        });
                    });
                }
            });
        }
    }

    removeDisabledBtnNext() {
        const methods = this.wrapper.querySelectorAll('[data-select-method-item]');
        if (methods.length) {
            methods.forEach(method => {
                method.addEventListener('click', () => {
                    this.wrapper.querySelector('[data-pay-window-btn-next]').classList.remove('disabled');
                });
            });
        }
    }

    billCopy() {
        const copyBtn = this.wrapper.querySelector('[data-bill-copy]');
        if (copyBtn) {
            const tooltip = this.wrapper.querySelector('[data-bill-copy-tooltip]');
            let tooltipIsVisible = false;

            copyBtn.addEventListener('click', () => {
                const bill = this.wrapper.querySelector('[data-bill-insert]').textContent;
                window.navigator.clipboard.writeText(bill);
                if (bill.length && !tooltipIsVisible) {
                    tooltipIsVisible = true;
                    tooltip.classList.add('bill-tooltip-visible');
                    setTimeout(() => {
                        tooltip.classList.remove('bill-tooltip-visible');
                        tooltipIsVisible = false;
                    }, 1000);
                }
            });
        }
    }
}

let payWindow;
let modalWindow;

if (document.querySelector('.modal-pay') !== null) {
    payWindow = new PayWindow({wrapper: '.modal-pay', buttonTrigger: 'data-open-pay-window'});
    payWindow.init();
}

if (document.querySelector('.modal-ask-questions') !== null) {
    modalWindow = new ModalWindow({wrapper: '.modal-ask-questions', buttonTrigger: 'data-open-modal-window'});
    modalWindow.init();
}